import { app } from "modular-openscriptjs";
import { EchoEventListener } from "./classes/EchoEventListener";
import { channelRoutes } from "./echo-channels";
/**
 * @type {EchoEventListener} echoEventListener
 */
let echoEventListener = app("EchoEventListener");

/** Order events broadcast on the `orders.user.{user_id}` private channel */
const ORDER_EVENTS = [
    "OrderStatusChanged",
    "OrderUpdated",
    "OrderConfirmed",
    "OrderCancelled",
];

export function activateEchoListeners() {
    echoEventListener.listenToNotifications(channelRoutes.currentUser());

    const ordersChannel = channelRoutes.ordersForUser();
    for (const event of ORDER_EVENTS) {
        echoEventListener.listen(ordersChannel, event, "private");
    }
}

export function deactivateEchoListeners() {
    echoEventListener.stopListeningToNotifications(channelRoutes.currentUser());

    const ordersChannel = channelRoutes.ordersForUser();
    for (const event of ORDER_EVENTS) {
        echoEventListener.stopListening(ordersChannel, event, "private");
    }
}
